// import React, { useState, useEffect, useRef } from "react";
// import httpClient from "../../utils/httpClients";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import {useProfile} from "../../../context"

// function AccountSetting() {
//   const navigate = useNavigate();
//   const fileInputRef = useRef(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [errors, setErrors] = useState({});
//   const [subscriptionActive, setSubscriptionActive] = useState(null);

//   const { updateProfilePic } = useProfile();

//   const [showPassword, setShowPassword] = useState({
//     oldPassword: false,
//     newPassword: false,
//     confirmPassword: false,
//   });

//   const [profileData, setProfileData] = useState({
//     firstName: "",
//     email: "",
//     oldPassword: "",
//     newPassword: "",
//     confirmPassword: "",
//     profileImage: null,
//     previewImage: `${process.env.PUBLIC_URL}/assets/images/dashboard/64.jpg`,
//   });

//   useEffect(() => {
//     fetchAccount();
//     fetchActiveSubscription();
//   }, []);
// const handleSubscription = () => {
//   navigate("/subscription");
// };

//   const fetchAccount = async () => {
//     try {
//       const res = await httpClient.get("/user/profile/get-profile");
//       if (res.data && res.data.success) {
//         const userData = res.data.data?.userProfile || {};
//         setProfileData((prev) => ({
//           ...prev,
//           firstName: userData.firstName || "",
//           email: userData.email || "",
//           previewImage:
//             userData.profilePic ||
//             `${process.env.PUBLIC_URL}/assets/images/dashboard/64.jpg`,
//         }));
//       }
//     } catch (err) {
//       console.error("Error fetching profile:", err);
//     }
//   };

//   const fetchActiveSubscription = async () => {
//     try {
//       const res = await httpClient.get("/user/user-subscription/active");
//       if (res.data && res.data.success) {
//         const activeSubscriptions = res.data.data?.activeSubscriptions || [];
//         const activeSubscription = activeSubscriptions[0] || null;
//         setSubscriptionActive(activeSubscription);
//       }
//     } catch (err) {
//       console.error("Error fetching subscription:", err);
//       setSubscriptionActive(null);
//     }
//   };

//   const validateForm = () => {
//     const newErrors = {};

//     // First name validation
//     if (!profileData.firstName.trim()) {
//       newErrors.firstName = "First name is required";
//     }

//     // Email validation
//     if (!profileData.email.trim()) {
//       newErrors.email = "Email is required";
//     } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(profileData.email)) {
//       newErrors.email = "Please enter a valid email address";
//     }

//     if (
//       profileData.oldPassword ||
//       profileData.newPassword ||
//       profileData.confirmPassword
//     ) {
//       // Old password validation (max 15 characters)
//       if (!profileData.oldPassword) {
//         newErrors.oldPassword = "Current password is required to change password";
//       } else if (profileData.oldPassword.length > 16) {
//         newErrors.oldPassword = "Current password cannot exceed 16 characters";
//       }

//       // New password validation
//       if (!profileData.newPassword) {
//         newErrors.newPassword = "New password is required";
//       } else {
//         if (profileData.newPassword.length < 8 || profileData.newPassword.length > 16) {
//           newErrors.newPassword = "Password must be between 8 and 16 characters";
//         } else if (!/(?=.*[a-z])/.test(profileData.newPassword)) {
//           newErrors.newPassword = "Password must contain at least one lowercase letter";
//         } else if (!/(?=.*[A-Z])/.test(profileData.newPassword)) {
//           newErrors.newPassword = "Password must contain at least one uppercase letter";
//         }
//       }

//       if (!profileData.confirmPassword) {
//         newErrors.confirmPassword = "Please confirm your new password";
//       } else if (profileData.newPassword !== profileData.confirmPassword) {
//         newErrors.confirmPassword = "Passwords do not match";
//       }
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;

//     // Limit oldPassword to 15 characters
//     if (name === "oldPassword" && value.length > 16) {
//       return;
//     }

//     setProfileData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));

//     // Clear error when user starts typing
//     if (errors[name]) {
//       setErrors((prev) => ({
//         ...prev,
//         [name]: "",
//       }));
//     }
//   };

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       // Validate file type
//       if (!file.type.match("image.*")) {
//         setErrors((prev) => ({
//           ...prev,
//           profileImage: "Please select an image file",
//         }));
//         return;
//       }

//       // Validate file size (max 5MB)
//       if (file.size > 5 * 1024 * 1024) {
//         setErrors((prev) => ({
//           ...prev,
//           profileImage: "Image must be less than 5MB",
//         }));
//         return;
//       }

//       // console.log("profile => ", file)

//       const reader = new FileReader();
//       reader.onloadend = () => {
//         const newPreviewImage = reader.result;

//         setProfileData((prev) => ({
//           ...prev,
//           profileImage: file,
//           previewImage: newPreviewImage,
//         }));

//         // Update localStorage with new profile image
//         updateLocalStorageProfileImage(newPreviewImage);

//         // Clear any previous image errors
//         if (errors.profileImage) {
//           setErrors((prev) => ({
//             ...prev,
//             profileImage: "",
//           }));
//         }
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const updateLocalStorageProfileImage = (imageData) => {
//     try {
//       // Store the profile image in localStorage
//       localStorage.setItem('userProfileImage', imageData);

//       // You can also store a timestamp to track when it was updated
//       localStorage.setItem('profileImageUpdatedAt', new Date().toISOString());

//       console.log('Profile image updated in localStorage');
//     } catch (error) {
//       console.error('Error updating profile image in localStorage:', error);
//     }
//   };

//   const handleIconClick = () => {
//     fileInputRef.current.click();
//   };

//   const togglePasswordVisibility = (field) => {
//     setShowPassword((prev) => ({
//       ...prev,
//       [field]: !prev[field],
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateForm()) {
//       return;
//     }

//     setIsLoading(true);

//     try {
//       const formData = new FormData();
//       formData.append("firstName", profileData.firstName);
//       formData.append("email", profileData.email);

//       if (profileData.oldPassword) {
//         formData.append("oldPassword", profileData.oldPassword);
//       }

//       if (profileData.newPassword) {
//         formData.append("newPassword", profileData.newPassword);
//       }

//       if (profileData.profileImage) {
//         formData.append("file", profileData.profileImage);
//       }

//       const res = await httpClient.put(
//         "/user/profile/update-profile",
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );
//       console.log("res => ", res.data.data.profilePic);
//       updateProfilePic(res.data.data.profilePic);

//       if (res.data?.message) {
//         toast.success(res.data.message, {
//           autoClose: 3000,
//           position: "top-right",
//         });
//       }

//       if (res.data && res.data.success) {
//         // Clear password fields
//         setProfileData((prev) => ({
//           ...prev,
//           oldPassword: "",
//           newPassword: "",
//           confirmPassword: "",
//           profileImage: null,
//         }));

//         // If profile image was updated, ensure it's in localStorage
//         if (profileData.profileImage) {
//           updateLocalStorageProfileImage(profileData.previewImage);
//         }
//       }
//     } catch (err) {
//       console.error("Error updating profile:", err);
//       toast.error("Failed to update profile. Please try again.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // Function to get subscription display name
//   const getSubscriptionDisplayName = () => {
//     if (!subscriptionActive) return "No Active Subscription";

//     return subscriptionActive.planId?.name || "Basic Listener";
//   };

//   // Function to get subscription features
//   const getSubscriptionFeatures = () => {
//     if (!subscriptionActive) return [
//       "Unlimited Downloads",
//       "Create Playlists & Share",
//       "30MB of Storage Space"
//     ];

//     return subscriptionActive.planId?.features || [
//       "Unlimited Downloads",
//       "Create Playlists & Share",
//       "30MB of Storage Space"
//     ];
//   };

//   // Function to format date
//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";

//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'long',
//       day: 'numeric'
//     });
//   };

//   // Function to get subscription status badge
//   const getStatusBadge = (status) => {
//     const statusConfig = {
//       active: { class: "bg-success", text: "Active" },
//       expired: { class: "bg-danger", text: "Expired" },
//       cancelled: { class: "bg-warning", text: "Cancelled" },
//       pending: { class: "bg-info", text: "Pending" }
//     };

//     const config = statusConfig[status] || { class: "bg-secondary", text: status };

//     return `<span class="badge ${config.class}">${config.text}</span>`;
//   };

//   return (
//     <div className="content-inner pb-0 container-fluid" id="page_layout">
//       <div className="row mb-5">
//         <div className="col-lg-12">
//           <div className="card-header">
//             <div className="header-title">
//               <h2 className="card-title text-capitalize mb-3">
//                 Account Settings
//               </h2>
//             </div>
//           </div>
//         </div>
//         <div className="col-xl-3 col-lg-4">
//           <div className="card">
//             <div className="card-header d-flex justify-content-between">
//               <div className="header-title">
//                 <h4 className="card-title">Choose Image</h4>
//               </div>
//             </div>
//             <div className="card-body profile1">
//               <div className="form-group">
//                 <div className="profile-img-edit position-relative">
//                   <img
//                     src={profileData.previewImage}
//                     alt="profile-pic"
//                     className="theme-color-default-img profile-pic rounded avatar-100"
//                     loading="lazy"
//                   />
//                   <div
//                     className="upload-icone bg-primary"
//                     onClick={handleIconClick}
//                     style={{ cursor: "pointer" }}
//                   >
//                     <svg
//                       className="upload-button icon-14"
//                       width={14}
//                       height={14}
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         fill="#ffffff"
//                         d="M14.06,9L15,9.94L5.92,19H5V18.08L14.06,9M17.66,3C17.41,3 17.15,3.1 16.96,3.29L15.13,5.12L18.88,8.87L20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18.17,3.09 17.92,3 17.66,3M14.06,6.19L3,17.25V21H6.75L17.81,9.94L14.06,6.19Z"
//                       />
//                     </svg>
//                     <input
//                       ref={fileInputRef}
//                       className="file-upload"
//                       type="file"
//                       accept="image/*"
//                       onChange={handleImageChange}
//                       style={{
//                         position: "absolute",
//                         top: 0,
//                         left: 0,
//                         width: "100%",
//                         height: "100%",
//                         opacity: 0,
//                         cursor: "pointer",
//                       }}
//                     />
//                   </div>
//                 </div>
//                 {errors.profileImage && (
//                   <div className="text-danger small mt-2">
//                     {errors.profileImage}
//                   </div>
//                 )}
//                 <div className="mt-3 text-center">
//                   <button
//                     type="button"
//                     className="btn btn-sm btn-outline-primary"
//                     onClick={handleIconClick}
//                   >
//                     Change Image
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="col-12 col-lg-8">
//           <form
//             onSubmit={handleSubmit}
//             className="sign__form sign__form--profile card"
//           >
//             <div className="row">
//               <div className="col-12">
//                 <h4 className="sign__title">Profile details</h4>
//               </div>
//               <div className="col-12 col-md-12 col-lg-12 col-xl-12">
//                 <div className="sign__group">
//                   <label className="sign__label" htmlFor="firstName">
//                     First Name
//                   </label>
//                   <input
//                     id="firstName"
//                     type="text"
//                     name="firstName"
//                     value={profileData.firstName}
//                     onChange={handleInputChange}
//                     className={`sign__input ${
//                       errors.firstName ? "is-invalid" : ""
//                     }`}
//                     placeholder="Your First Name"
//                   />
//                   {errors.firstName && (
//                     <div className="text-danger small mt-1">
//                       {errors.firstName}
//                     </div>
//                   )}
//                 </div>
//               </div>
//               <div className="col-12 col-md-12 col-lg-12 col-xl-12">
//                 <div className="sign__group">
//                   <label className="sign__label" htmlFor="email">
//                     Email
//                   </label>
//                   <input
//                     id="email"
//                     type="email"
//                     name="email"
//                     value={profileData.email}
//                     onChange={handleInputChange}
//                     className={`sign__input ${
//                       errors.email ? "is-invalid" : ""
//                     }`}
//                     placeholder="your.email@example.com"
//                   />
//                   {errors.email && (
//                     <div className="text-danger small mt-1">{errors.email}</div>
//                   )}
//                 </div>
//               </div>

//               <div className="col-12">
//                 <h4 className="sign__title mt-4">Change Password</h4>
//               </div>

//               <div className="col-12 col-md-6 col-lg-12 col-xl-6">
//                 <div className="sign__group position-relative">
//                   <label className="sign__label" htmlFor="oldPassword">
//                     Current Password
//                   </label>
//                   <input
//                     id="oldPassword"
//                     type={showPassword.oldPassword ? "text" : "password"}
//                     name="oldPassword"
//                     value={profileData.oldPassword}
//                     onChange={handleInputChange}
//                     className={`sign__input ${
//                       errors.oldPassword ? "is-invalid" : ""
//                     }`}
//                     placeholder="Current password (max 15 chars)"
//                     maxLength={15}
//                   />
//                   <span
//                     className="position-absolute eye-icon"
//                     style={{ right: "10px", top: "38px", cursor: "pointer" }}
//                     onClick={() => togglePasswordVisibility("oldPassword")}
//                   >
//                     {showPassword.oldPassword ? (
//                       <i className="fa fa-eye-slash"></i>
//                     ) : (
//                       <i className="fa fa-eye"></i>
//                     )}
//                   </span>
//                   {errors.oldPassword && (
//                     <div className="text-danger small mt-1">
//                       {errors.oldPassword}
//                     </div>
//                   )}
//                 </div>
//               </div>
//               <div className="col-12 col-md-6 col-lg-12 col-xl-6">
//                 <div className="sign__group position-relative">
//                   <label className="sign__label" htmlFor="newPassword">
//                     New Password
//                   </label>
//                   <input
//                     id="newPassword"
//                     type={showPassword.newPassword ? "text" : "password"}
//                     name="newPassword"
//                     value={profileData.newPassword}
//                     onChange={handleInputChange}
//                     className={`sign__input ${
//                       errors.newPassword ? "is-invalid" : ""
//                     }`}
//                     placeholder="New password (15 chars)"
//                     maxLength={12}
//                   />
//                   <span
//                     className="position-absolute eye-icon"
//                     style={{ right: "10px", top: "38px", cursor: "pointer" }}
//                     onClick={() => togglePasswordVisibility("newPassword")}
//                   >
//                     {showPassword.newPassword ? (
//                       <i className="fa fa-eye-slash"></i>
//                     ) : (
//                       <i className="fa fa-eye"></i>
//                     )}
//                   </span>
//                   {errors.newPassword && (
//                     <div className="text-danger small mt-1">
//                       {errors.newPassword}
//                     </div>
//                   )}
//                 </div>
//               </div>
//               <div className="col-12 col-md-6 col-lg-12 col-xl-6">
//                 <div className="sign__group position-relative">
//                   <label className="sign__label" htmlFor="confirmPassword">
//                     Confirm Password
//                   </label>
//                   <input
//                     id="confirmPassword"
//                     type={showPassword.confirmPassword ? "text" : "password"}
//                     name="confirmPassword"
//                     value={profileData.confirmPassword}
//                     onChange={handleInputChange}
//                     className={`sign__input ${
//                       errors.confirmPassword ? "is-invalid" : ""
//                     }`}
//                     placeholder="Confirm new password"
//                     maxLength={12}
//                   />
//                   <span
//                     className="position-absolute eye-icon"
//                     style={{ right: "10px", top: "38px", cursor: "pointer" }}
//                     onClick={() => togglePasswordVisibility("confirmPassword")}
//                   >
//                     {showPassword.confirmPassword ? (
//                       <i className="fa fa-eye-slash"></i>
//                     ) : (
//                       <i className="fa fa-eye"></i>
//                     )}
//                   </span>
//                   {errors.confirmPassword && (
//                     <div className="text-danger small mt-1">
//                       {errors.confirmPassword}
//                     </div>
//                   )}
//                 </div>
//               </div>
//               <div className="col-12">
//                 <button
//                   className="sign__btn"
//                   type="submit"
//                   disabled={isLoading}
//                 >
//                   {isLoading ? "Saving..." : "Save Changes"}
//                 </button>
//               </div>
//             </div>
//           </form>
//         </div>

//         {/* Subscription Section */}
//         <div className="col-12 mt-4">
//           <div className="card">
//             <div className="card-header">
//               <h4 className="card-title">Subscription Details</h4>
//             </div>
//             <div className="card-body">
//               {subscriptionActive ? (
//                 <div className="row">
//                   <div className="col-lg-8">
//                     <div className="card pricing-box-2 mb-lg-0">
//                       <div className="card-body">
//                         <div className="d-flex justify-content-between align-items-start mb-3">
//                           <div>
//                             <p className="text-muted mb-1">Subscribed to</p>
//                             <h3 className="mb-2">{getSubscriptionDisplayName()}</h3>
//                             <span
//                               className={`badge ${
//                                 subscriptionActive.status === 'active' ? 'bg-success' :
//                                 subscriptionActive.status === 'expired' ? 'bg-danger' : 'bg-warning'
//                               }`}
//                             >
//                               {subscriptionActive.status?.toUpperCase()}
//                             </span>
//                           </div>
//                           <div className="text-end">
//                             <h4 className="text-primary">
//                               ${subscriptionActive.planId?.price}/{subscriptionActive.planId?.billingCycle}
//                             </h4>
//                             <small className="text-muted">{subscriptionActive.planId?.currency}</small>
//                           </div>
//                         </div>

//                         <div className="row mb-4">
//                           <div className="col-md-6">
//                             <p><strong>Start Date:</strong> {formatDate(subscriptionActive.startDate)}</p>
//                           </div>
//                           <div className="col-md-6">
//                             <p><strong>End Date:</strong> {formatDate(subscriptionActive.endDate)}</p>
//                           </div>

//                           <div className="col-md-6">
//                             <p><strong>Plan Type:</strong> {subscriptionActive.planId?.type}</p>
//                           </div>
//                         </div>

//                         <h5>Features:</h5>
//                         <ul className="p-0 mb-4 list-unstyled">
//                           {getSubscriptionFeatures().map((feature, index) => (
//                             <li key={index}>
//                               <p className="mb-2">
//                                 <svg
//                                   width={8}
//                                   className="me-2"
//                                   viewBox="0 0 8 8"
//                                   fill="none"
//                                   xmlns="http://www.w3.org/2000/svg"
//                                 >
//                                   <circle cx={4} cy={4} r={4} fill="currentColor" />
//                                 </svg>
//                                 {feature}
//                               </p>
//                             </li>
//                           ))}
//                         </ul>

//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               ) : (
//                 <div className="text-center py-4">
//   <h5>No Active Subscription</h5>
//   <p className="text-muted">
//     You don't have an active subscription plan.
//   </p>
//   <button
//     onClick={handleSubscription}
//     className="btn btn-primary"
//   >
//     Please choose a new subscription plan
//   </button>
// </div>

//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default AccountSetting;

import React, { useState, useEffect, useRef } from "react";
import httpClient from "../../utils/httpClients";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useProfile } from "../../../context";

function AccountSetting() {
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [subscriptionActive, setSubscriptionActive] = useState(null);
  console.log("subscriptionActive", subscriptionActive);

  const { updateProfilePic } = useProfile();

  const [showPassword, setShowPassword] = useState({
    oldPassword: false,
    newPassword: false,
    confirmPassword: false,
  });

  const [profileData, setProfileData] = useState({
    firstName: "",
    email: "",
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
    profileImage: null,
    previewImage: "",
  });

  useEffect(() => {
    fetchAccount();
    fetchActiveSubscription();
  }, []);

  const handleSubscription = () => {
    navigate("/subscription");
  };

  const fetchAccount = async () => {
    try {
      const res = await httpClient.get("/user/profile/get-profile");
      if (res.data && res.data.success) {
        const userData = res.data.data?.userProfile || {};
        setProfileData((prev) => ({
          ...prev,
          firstName: userData.firstName || "",
          email: userData.email || "",
          previewImage:
            userData.profilePic ||
            `${process.env.PUBLIC_URL}/assets/images/dashboard/userLogo.jpeg`,
        }));
      }
    } catch (err) {
      console.error("Error fetching profile:", err);
    }
  };

  const fetchActiveSubscription = async () => {
    try {
      const res = await httpClient.get("/user/user-subscription/active");
      if (res.data && res.data.success) {
        const activeSubscriptions = res.data.data?.activeSubscriptions || [];
        const activeSubscription = activeSubscriptions[0] || null;
        console.log("Active Subscription => ", activeSubscription);
        setSubscriptionActive(activeSubscription);
      }
    } catch (err) {
      console.error("Error fetching subscription:", err);
      setSubscriptionActive(null);
    }
  };

  const validateForm = () => {
    const newErrors = {};

    // First name validation
    if (!profileData.firstName.trim()) {
      newErrors.firstName = "First name is required";
    }

    // Email validation
    // if (!profileData.email.trim()) {
    //   newErrors.email = "Email is required";
    // } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(profileData.email)) {
    //   newErrors.email = "Please enter a valid email address";
    // }

    if (
      profileData.oldPassword ||
      profileData.newPassword ||
      profileData.confirmPassword
    ) {
      // Old password validation (8-16 chars)
      if (!profileData.oldPassword) {
        newErrors.oldPassword =
          "Current password is required to change password";
      }
      // else if (
      //   profileData.oldPassword.length < 8 ||
      //   profileData.oldPassword.length > 16
      // ) {
      //   newErrors.oldPassword =
      //     "Current password must be between 8 and 16 characters. It must contain at least one lowercase letter, one uppercase letter, a number and a special character";
      // }

      // New password validation
      if (!profileData.newPassword) {
        newErrors.newPassword = "New password is required";
      } else {
        if (
          profileData.newPassword.length < 8 ||
          profileData.newPassword.length > 16
        ) {
          newErrors.newPassword =
            "Password must be between 8 and 16 characters. It must contain at least one lowercase letter, one uppercase letter, a number and a special character";
        }
        // else if (!/(?=.*[a-z])/.test(profileData.newPassword)) {
        //   newErrors.newPassword =
        //     "Password must contain at least one lowercase letter";
        // } else if (!/(?=.*[A-Z])/.test(profileData.newPassword)) {
        //   newErrors.newPassword =
        //     "Password must contain at least one uppercase letter";
        // }
      }

      if (!profileData.confirmPassword) {
        newErrors.confirmPassword = "Please confirm your new password";
      } else if (profileData.newPassword !== profileData.confirmPassword) {
        newErrors.confirmPassword = "Passwords do not match";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Block >16 chars for all password fields
    if (
      ["oldPassword", "newPassword", "confirmPassword"].includes(name) &&
      value.length > 16
    ) {
      return;
    }

    setProfileData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.match("image.*")) {
        setErrors((prev) => ({
          ...prev,
          profileImage: "Please select an image file",
        }));
        return;
      }

      if (file.size > 5 * 1024 * 1024) {
        setErrors((prev) => ({
          ...prev,
          profileImage: "Image must be less than 5MB",
        }));
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        const newPreviewImage = reader.result;
        setProfileData((prev) => ({
          ...prev,
          profileImage: file,
          previewImage: newPreviewImage,
        }));

        updateLocalStorageProfileImage(newPreviewImage);

        if (errors.profileImage) {
          setErrors((prev) => ({
            ...prev,
            profileImage: "",
          }));
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const updateLocalStorageProfileImage = (imageData) => {
    try {
      localStorage.setItem("userProfileImage", imageData);
      localStorage.setItem("profileImageUpdatedAt", new Date().toISOString());
      console.log("Profile image updated in localStorage");
    } catch (error) {
      console.error("Error updating profile image in localStorage:", error);
    }
  };

  const handleIconClick = () => {
    fileInputRef.current.click();
  };

  const togglePasswordVisibility = (field) => {
    setShowPassword((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsLoading(true);

    try {
      const formData = new FormData();
      formData.append("firstName", profileData.firstName);
      formData.append("email", profileData.email);

      if (profileData.oldPassword) {
        formData.append("oldPassword", profileData.oldPassword);
      }

      if (profileData.newPassword) {
        formData.append("newPassword", profileData.newPassword);
      }

      if (profileData.profileImage) {
        formData.append("file", profileData.profileImage);
      }

      const res = await httpClient.put(
        "/user/profile/update-profile",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      updateProfilePic(res.data.data.profilePic);

      // if (res.data?.message) {
      //   toast.success(res.data.message, {
      //     autoClose: 3000,
      //     position: "top-right",
      //   });
      // }

      if (res.data && res.data.success) {
        setProfileData((prev) => ({
          ...prev,
          oldPassword: "",
          newPassword: "",
          confirmPassword: "",
          profileImage: null,
        }));

        if (profileData.profileImage) {
          updateLocalStorageProfileImage(profileData.previewImage);
        }
      }
    } catch (err) {
      console.error("Error updating profile:", err);
      // toast.error("Failed to update profile. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const getSubscriptionDisplayName = () => {
    if (!subscriptionActive) return "No Active Subscription";
    return subscriptionActive.planId?.name || "Basic Listener";
  };

  const getSubscriptionFeatures = () => {
    if (!subscriptionActive)
      return [
        "Unlimited Downloads",
        "Create Playlists & Share",
        "30MB of Storage Space",
      ];
    return (
      subscriptionActive.planId?.features || [
        "Unlimited Downloads",
        "Create Playlists & Share",
        "30MB of Storage Space",
      ]
    );
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
    <div className="content-inner pb-0 container-fluid" id="page_layout">
      <div className="row mb-5">
        <div className="col-lg-12">
          <div className="card-header">
            <div className="header-title">
              <h2 className="card-title text-capitalize mb-3">
                Account Settings
              </h2>
            </div>
          </div>
        </div>

        {/* Profile Image */}
        <div className="col-xl-3 col-lg-4">
          <div className="card">
            <div className="card-header d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">Choose Image</h4>
              </div>
            </div>
            <div className="card-body profile1">
              <div className="form-group">
                <div className="profile-img-edit position-relative">
                  <img
                    src={
                      profileData.previewImage ||
                      `${process.env.PUBLIC_URL}/assets/images/dashboard/mode-portrait.png`
                    }
                    alt="profile-pic"
                    className="theme-color-default-img profile-pic rounded avatar-100"
                    loading="lazy"
                    style={{ height: "25vh", objectFit: "contain" }}
                  />
                  <div
                    className="upload-icone bg-primary"
                    onClick={handleIconClick}
                    style={{ cursor: "pointer" }}
                  >
                    <svg
                      className="upload-button icon-14"
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="#ffffff"
                        d="M14.06,9L15,9.94L5.92,19H5V18.08L14.06,9M17.66,3C17.41,3 17.15,3.1 16.96,3.29L15.13,5.12L18.88,8.87L20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18.17,3.09 17.92,3 17.66,3M14.06,6.19L3,17.25V21H6.75L17.81,9.94L14.06,6.19Z"
                      />
                    </svg>
                    <input
                      ref={fileInputRef}
                      className="file-upload"
                      type="file"
                      accept="image/*"
                      onChange={handleImageChange}
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        opacity: 0,
                        cursor: "pointer",
                      }}
                    />
                  </div>
                </div>
                {errors.profileImage && (
                  <div className="text-danger small mt-2">
                    {errors.profileImage}
                  </div>
                )}
                <div className="mt-3 text-center">
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={handleIconClick}
                  >
                    Change Image
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Profile Form */}
        <div className="col-12 col-lg-8">
          <form
            onSubmit={handleSubmit}
            className="sign__form sign__form--profile card"
          >
            <div className="row">
              <div className="col-12">
                <h4 className="sign__title">Profile details</h4>
              </div>

              {/* First Name */}
              <div className="col-12 col-md-12 col-lg-12 col-xl-12">
                <div className="sign__group">
                  <label className="sign__label" htmlFor="firstName">
                    First Name
                  </label>
                  <input
                    id="firstName"
                    type="text"
                    name="firstName"
                    value={profileData.firstName}
                    onChange={handleInputChange}
                    className={`sign__input ${errors.firstName ? "is-invalid" : ""}`}
                    placeholder="Your First Name"
                  />
                  {errors.firstName && (
                    <div className="text-danger small mt-1">
                      {errors.firstName}
                    </div>
                  )}
                </div>
              </div>

              {/* Email */}
              <div className="col-12 col-md-12 col-lg-12 col-xl-12">
                <div className="sign__group">
                  <label className="sign__label" htmlFor="email">
                    Email
                  </label>
                  <input
                    id="email"
                    type="email"
                    name="email"
                    value={profileData.email}
                    disabled
                    // onChange={handleInputChange}
                    className={`sign__input ${errors.email ? "is-invalid" : ""}`}
                    placeholder="your.email@example.com"
                    style={{ color: "#747272" }}
                  />
                  {errors.email && (
                    <div className="text-danger small mt-1">{errors.email}</div>
                  )}
                </div>
              </div>

              {/* Change Password */}
              <div className="col-12">
                <h4 className="sign__title mt-4">Change Password</h4>
              </div>

              {/* Current Password */}
              <div className="col-12 col-md-6 col-lg-12 col-xl-6">
                <div className="sign__group position-relative">
                  <label className="sign__label" htmlFor="oldPassword">
                    Current Password
                  </label>
                  <input
                    id="oldPassword"
                    type={showPassword.oldPassword ? "text" : "password"}
                    name="oldPassword"
                    value={profileData.oldPassword}
                    onChange={handleInputChange}
                    className={`sign__input ${errors.oldPassword ? "is-invalid" : ""}`}
                    placeholder="Current password (max 15 chars)"
                    maxLength={16}
                  />
                  <span
                    className="position-absolute eye-icon"
                    style={{ right: "10px", top: "38px", cursor: "pointer" }}
                    onClick={() => togglePasswordVisibility("oldPassword")}
                  >
                    {showPassword.oldPassword ? (
                      <i className="fa fa-eye"></i>
                    ) : (
                      <i className="fa fa-eye-slash"></i>
                    )}
                  </span>
                  {errors.oldPassword && (
                    <div className="text-danger small mt-1">
                      {errors.oldPassword}
                    </div>
                  )}
                </div>
              </div>

              {/* New Password */}
              <div className="col-12 col-md-6 col-lg-12 col-xl-6">
                <div className="sign__group position-relative">
                  <label className="sign__label" htmlFor="newPassword">
                    New Password
                  </label>
                  <input
                    id="newPassword"
                    type={showPassword.newPassword ? "text" : "password"}
                    name="newPassword"
                    value={profileData.newPassword}
                    onChange={handleInputChange}
                    className={`sign__input ${errors.newPassword ? "is-invalid" : ""}`}
                    placeholder="New password (15 chars)"
                    maxLength={16}
                  />
                  <span
                    className="position-absolute eye-icon"
                    style={{ right: "10px", top: "38px", cursor: "pointer" }}
                    onClick={() => togglePasswordVisibility("newPassword")}
                  >
                    {showPassword.newPassword ? (
                      <i className="fa fa-eye"></i>
                    ) : (
                      <i className="fa fa-eye-slash"></i>
                    )}
                  </span>
                  {errors.newPassword && (
                    <div className="text-danger small mt-1">
                      {errors.newPassword}
                    </div>
                  )}
                </div>
              </div>

              {/* Confirm Password */}
              <div className="col-12 col-md-6 col-lg-12 col-xl-6">
                <div className="sign__group position-relative">
                  <label className="sign__label" htmlFor="confirmPassword">
                    Confirm Password
                  </label>
                  <input
                    id="confirmPassword"
                    type={showPassword.confirmPassword ? "text" : "password"}
                    name="confirmPassword"
                    value={profileData.confirmPassword}
                    onChange={handleInputChange}
                    className={`sign__input ${errors.confirmPassword ? "is-invalid" : ""}`}
                    placeholder="Confirm new password"
                    maxLength={16}
                  />
                  <span
                    className="position-absolute eye-icon"
                    style={{ right: "10px", top: "38px", cursor: "pointer" }}
                    onClick={() => togglePasswordVisibility("confirmPassword")}
                  >
                    {showPassword.confirmPassword ? (
                      <i className="fa fa-eye"></i>
                    ) : (
                      <i className="fa fa-eye-slash"></i>
                    )}
                  </span>
                  {errors.confirmPassword && (
                    <div className="text-danger small mt-1">
                      {errors.confirmPassword}
                    </div>
                  )}
                </div>
              </div>

              {/* Submit */}
              <div className="col-12">
                <button
                  className="sign__btn"
                  type="submit"
                  disabled={isLoading}
                >
                  {isLoading ? "Saving..." : "Save Changes"}
                </button>
              </div>
            </div>
          </form>
        </div>

        {/* Subscription Section */}
        <div className="col-12 mt-4">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Subscription Details</h4>
            </div>
            <div className="card-body">
              {subscriptionActive ? (
                <div className="row">
                  <div className="col-lg-8">
                    <div className="card pricing-box-2 mb-lg-0">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-start mb-3">
                          <div>
                            <p className="text-muted mb-1">Subscribed to</p>
                            <h3 className="mb-2">
                              {getSubscriptionDisplayName()}
                            </h3>
                            <span
                              className={`badge ${
                                subscriptionActive.status === "active"
                                  ? "bg-success"
                                  : subscriptionActive.status === "expired"
                                    ? "bg-danger"
                                    : "bg-warning"
                              }`}
                            >
                              {subscriptionActive.status?.toUpperCase()}
                            </span>
                          </div>
                          {subscriptionActive.planId?.planKey !== "basic" && (
                            <div className="text-end">
                              <h4 className="text-primary">
                                ${subscriptionActive.planId?.price}/
                                {subscriptionActive.planId?.billingCycle}
                              </h4>
                              <small className="text-muted">
                                {subscriptionActive.planId?.currency}
                              </small>
                            </div>
                          )}
                        </div>
                        {subscriptionActive.planId?.planKey !== "basic" && (
                          <div className="row mb-4">
                            <div className="col-md-6">
                              <p>
                                <strong>Start Date:</strong>{" "}
                                {formatDate(subscriptionActive.startDate)}
                              </p>
                            </div>
                            <div className="col-md-6">
                              <p>
                                <strong>End Date:</strong>{" "}
                                {formatDate(subscriptionActive.endDate)}
                              </p>
                            </div>

                            <div className="col-md-6">
                              <p>
                                <strong>Plan Type:</strong>{" "}
                                {subscriptionActive.planId?.type}
                              </p>
                            </div>
                          </div>
                        )}

                        <h5>Features:</h5>
                        <ul className="p-0 mb-4 list-unstyled">
                          {subscriptionActive.features &&
                            subscriptionActive.features.length > 0 &&
                            subscriptionActive.features.map(
                              (feature, index) => (
                                <li key={index}>
                                  <p className="mb-2">
                                    <svg
                                      width={8}
                                      className="me-2"
                                      viewBox="0 0 8 8"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <circle
                                        cx={4}
                                        cy={4}
                                        r={4}
                                        fill="currentColor"
                                      />
                                    </svg>
                                    {feature
                                      .replace(/_/g, " ")
                                      .replace(/\b\w/g, (char) =>
                                        char.toUpperCase(),
                                      )}
                                  </p>
                                </li>
                              ),
                            )}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="text-center py-4">
                  <h5>No Active Subscription</h5>
                  <p className="text-muted">
                    You don't have an active subscription plan.
                  </p>
                  <button
                    onClick={handleSubscription}
                    className="btn btn-primary"
                  >
                    Please choose a new subscription plan
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccountSetting;
